

/* tslint:disable */



export enum ComponentSortBy {
    Default = 0,
    Title = 1,
    Author = 2,
    Reviewer = 3,
    Version = 4,
    Type = 5,
    State = 6,

}


